// extracted by mini-css-extract-plugin
module.exports = {"w1i36oe9":"w1i36oe9","i1l2wjzs":"i1l2wjzs"};